// Wait for the DOM content to be fully loaded
document.addEventListener("DOMContentLoaded", () => {
    // Intro Animation Duration in ms (milliseconds)
    let animationDuration = 750;

    // Get the box width and put to Progress Bar
    const boxResults = document.querySelector('.js-box-results');
    const offsetWidth = boxResults.offsetWidth;
    const progressBar = document.querySelector('.js-progress-bar');

    // This function will be called whenever the window is resized
    if (window.innerWidth <= 480) {
        var offsetPadding = 20;
    } else if (window.innerWidth <= 575) {
        var offsetPadding = 30;
    } else if (window.innerWidth <= 750) {
        var offsetPadding = 40;
    } else {
        var offsetPadding = 60;
    }
    // Dynamic width of the progress bar
    const progressBarWidth = offsetWidth - offsetPadding;
    progressBar.style.setProperty('--progress-bar-width', progressBarWidth + 'px');

    // Resize the progress bar on window resize
    const reportWindowSize = () => {
        const offsetWidth = boxResults.offsetWidth;

        // This function will be called whenever the window is resized
        if (window.innerWidth <= 480) {
            var offsetPadding = 20;
        } else if (window.innerWidth <= 575) {
            var offsetPadding = 30;
        } else if (window.innerWidth <= 750) {
            var offsetPadding = 40;
        } else {
            var offsetPadding = 60;
        }

        const progressBarWidth = offsetWidth - offsetPadding;
        progressBar.style.setProperty('--progress-bar-width', progressBarWidth + 'px');
    }

    window.onresize = reportWindowSize;

    // Wait for the intro element 750ms before all code start running
    setTimeout(() => {
        const introElement = document.querySelector('.intro');
        introElement.classList.add('intro-stop');
            
        // Get parameters from the URL
        const urlParams = new URLSearchParams(window.location.search);
        // Get the value of the 'qs' parameter
        let stepPercent = urlParams.get('qs');

        const boxTxt = document.querySelector('.js-box-txt');
        const boxList = document.querySelector('.js-box-list');

        const listItems = document.querySelectorAll(".js-list-risk li");
        const text = document.querySelector(".js-box-txt p");
        let delay = animationDuration + 150; // Set the initial delay to reveal the list items and text
        let animateListItems = false; // Boolean variable to control list item animation

        // Check if qs parameter exists and is not NaN
        if (stepPercent !== null && stepPercent !== '' && !isNaN(stepPercent)) {
            // If qs parameter is greater than 100, set it to 100
            if (stepPercent > 100) {
                stepPercent = 100;
            }
        } else {
            // If qs parameter doesn't exist or is empty or NaN, set it to 0.0
            stepPercent = 0.0;
            boxTxt.classList.add('show');
        }
        
        // Set the CSS custom property '--step-percent' with the obtained value
        const stepNumber = parseFloat(stepPercent) / 10;

        const progressBarFill = document.querySelector('.js-progress-bar-positive');
        const progressBarStep = document.querySelector('.js-progress-bar-step');
        const dataScore = document.querySelector('.js-score-current');

        // Set the CSS custom property '--step-percent' with the obtained value
        if (stepNumber >= 0 && stepNumber <= 1.6) {
           
            if (window.innerWidth <= 575) {
                progressBarStep.style.setProperty('--step-percent', '15' + '%');
                progressBarFill.setAttribute('data-step-percent', '15' + '%');
                progressBarFill.style.setProperty('--step-percent', '15' + '%');
            } else {
                progressBarStep.style.setProperty('--step-percent', '6' + '%');
                progressBarFill.setAttribute('data-step-percent', '6' + '%');
                progressBarFill.style.setProperty('--step-percent', '6' + '%');
            }

        } else {
            progressBarStep.style.setProperty('--step-percent', stepPercent + '%');
            progressBarFill.setAttribute('data-step-percent', stepPercent + '%');
            progressBarFill.style.setProperty('--step-percent', stepPercent + '%');
        }

        // Get the value of 'data-step-percent' (left side) attribute to calculate right side
        const progressPercentLeft = progressBarFill.getAttribute('data-step-percent');
        const progressMath = 100 - parseFloat(progressPercentLeft.replace('%', ''));
    
        const progressPercentRight = document.querySelector('.js-progress-bar-negative');
        progressPercentRight.style.setProperty('--step-percent', progressMath + '%');

        // Set number to Progress Bar Step
        progressBarStep.setAttribute('data-step-number', stepNumber);
        // Set number to Your Score
        dataScore.setAttribute('data-score', stepNumber);

        const scoreStatus = document.querySelector('.js-score-status');
        
        let riskStatus = '';
        // Comments for readability of risk assessment conditions
        if (stepNumber >= 0 && stepNumber <= 1.6) {
            riskStatus = 'VERY LOW';
            scoreStatus.classList.add('txt--green');
            progressBarStep.classList.add('txt--green');
        } else if (stepNumber >= 1.7 && stepNumber <= 3.2) {
            riskStatus = 'LOW';
            scoreStatus.classList.add('txt--gold');
            progressBarStep.classList.add('txt--gold');
        } else if (stepNumber >= 3.3 && stepNumber <= 5.0) {
            riskStatus = 'MODERATE';
            scoreStatus.classList.add('txt--orange');
            progressBarStep.classList.add('txt--orange');
        } else if (stepNumber >= 5.1 && stepNumber <= 8.2) {
            riskStatus = 'HIGH';
            scoreStatus.classList.add('txt--red');
            progressBarStep.classList.add('txt--red');
        } else if (stepNumber >= 8.3 && stepNumber <= 10.0) {
            riskStatus = 'VERY HIGH';
            scoreStatus.classList.add('txt--red-dark');
            progressBarStep.classList.add('txt--red-dark');
        } 

        if (stepNumber >= 0.1 && stepNumber <= 10.0) {
            boxList.classList.add('show');
            animateListItems = true;
        } else {
            boxTxt.classList.add('show');
        }
        
        scoreStatus.textContent = riskStatus;
        
        // Define the list of parameters and their corresponding data attributes
        const paramMapping = {
            'hh': 'data-hh',
            'en': 'data-en',
            'in': 'data-in',
            'bs': 'data-bs',
            'ho': 'data-ho'
        };
        
        // Initialize an empty object to store parameter values
        const paramValues = {};
        
        // Loop through each parameter in the URL and set default value to 0 if not present
        for (const [param, dataAttr] of Object.entries(paramMapping)) {
            // Get the value of the parameter from the URL, default to 0 if not present
            const value = urlParams.get(param) === '1' ? '1' : '0';
            // Store the value in the paramValues object
            paramValues[dataAttr] = value;
        }
        
        // Get the list element
        const list = document.querySelector('.list-risk');
        
        // Loop through each list item and update its data attribute value
        for (const [dataAttr, value] of Object.entries(paramValues)) {
            list.querySelector(`li[${dataAttr}]`).setAttribute(dataAttr, value);
        }
        
        // Select the element with class '.score--current'
        const currentScoreSpan = document.querySelector('.score--current');
        
        // Get the target score value from 'data-score' attribute and parse it to float
        const targetScore = parseFloat(currentScoreSpan.getAttribute('data-score'));

        // Call the animateScore function to animate the score
        animateScore(currentScoreSpan, targetScore);

        // Function to animate the score
        function animateScore(element, targetScore) {
            // Duration of the animation in milliseconds
            const duration = 350; // You can adjust this value to change animation speed
            
            // Initial value of the score
            let start = 0.0;
            
            // Increment value to achieve the target score over the specified duration
            const increment = targetScore / (duration / 16); // 16ms is close to 60fps

            // Interval to update the score gradually
            const interval = setInterval(() => {
                // Increment the score
                start += increment;
                
                // Ensure the score does not exceed the target score
                if (start >= targetScore) {
                    clearInterval(interval);
                    start = targetScore;
                }
                
                // Update the displayed score
                element.textContent = start.toFixed(1); // Update the score with 1 decimal place
            }, 16); // Run at ~60fps
        }

        // Animated Reveal List items
        // Function to add 'active' class to elements after a delay
        const addActiveClass = (element, delay) => {
            setTimeout(() => {
            element.classList.add("active");
            }, delay);
        };

        // Animate list items
        if (animateListItems) {
            listItems.forEach(item => {
            addActiveClass(item, delay);
            delay += 200; // Increment the delay by 500 milliseconds
            });
        } else {
            // Animate text
            addActiveClass(text, delay);
        }

    }, animationDuration); // Adjust the delay (in milliseconds) 

});